/*----------------------------------
- BUYER WORKFLOW MOTION
- Decorative fake-data preview of a buyer shortlist becoming an outreach path.
----------------------------------*/

import Icon from '@/client/components/ui/icon/Icon';

/*----------------------------------
- CONTENT
----------------------------------*/

const BUYER_CANDIDATES = [
    { initials: 'NL', name: 'Northstar Labs', sector: 'AI infrastructure' },
    { initials: 'TC', name: 'Tandem Cloud', sector: 'Developer tools' },
    { initials: 'OS', name: 'Orbit Systems', sector: 'Data platforms' },
] as const;

/*----------------------------------
- COMPONENT
----------------------------------*/

const BuyerWorkflowMotion = () => (
    <div aria-hidden="true" class="ud-workflow-buyers">
        <div class="ud-workflow-buyers__shortlist">
            {BUYER_CANDIDATES.map((candidate, index) => (
                <div
                    key={candidate.name}
                    class={`ud-workflow-buyers__candidate ${index === 0 ? 'ud-workflow-buyers__candidate--selected' : ''}`}
                    style={{ animationDelay: `${index * 0.45}s` }}
                >
                    <span class="ud-workflow-buyers__candidate-avatar">{candidate.initials}</span>
                    <span class="ud-workflow-buyers__candidate-copy">
                        <strong>{candidate.name}</strong>
                        <span>{candidate.sector}</span>
                    </span>
                    <Icon name={index === 0 ? 'check' : 'arrow-right'} size={11} strokeWidth={2.2} />
                </div>
            ))}
        </div>

        <div class="ud-workflow-buyers__detail">
            <div class="ud-workflow-buyers__detail-header">
                <span class="ud-workflow-buyers__detail-avatar">NL</span>
                <span class="ud-workflow-buyers__detail-title">
                    <span>Likely buyer</span>
                    <strong>Northstar Labs</strong>
                </span>
            </div>

            <div class="ud-workflow-buyers__detail-row">
                <span class="ud-workflow-buyers__detail-icon">
                    <Icon name="sparkles" size={11} strokeWidth={2} />
                </span>
                <span>
                    <small>Why it fits</small>
                    <strong>Rebranding an AI platform</strong>
                </span>
            </div>
            <div class="ud-workflow-buyers__detail-row">
                <span class="ud-workflow-buyers__detail-icon">
                    <Icon name="user" size={11} strokeWidth={2} />
                </span>
                <span>
                    <small>Contact path</small>
                    <strong>Verified founder inbox</strong>
                </span>
            </div>

            <div class="ud-workflow-buyers__outreach">
                <span>
                    <small>Outreach angle</small>
                    <strong>Lead with category authority</strong>
                </span>
                <span class="ud-workflow-buyers__draft">
                    Draft outreach
                    <Icon name="arrow-right" size={11} strokeWidth={2.2} />
                </span>
            </div>
        </div>
    </div>
);

export default BuyerWorkflowMotion;
